export default __webpack_public_path__ + "static/media/toggle.1e9944c8.svg";